import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isProjectHistoryRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isProjectHistoryRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isProjectHistoryRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getProjectHistory() {
      return getState().projects;
    },
  };
}

export { createSelector };
